import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from 'src/app/common/data2.service';
import { FocustipService } from 'src/app/common/focustip/focustip.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';

import { MapComponent } from 'src/app/common/map/map.component';
import { MapService } from 'src/app/common/map/map.service';

@Component({
	selector: 'app-transport-templates-map',
	templateUrl: './transport-templates-map.component.html',
	styleUrls: ['./transport-templates-map.component.css'],
})
export class TransportTemplatesMapComponent implements OnInit {
	@ViewChild(MapComponent) mapComponent: MapComponent;

	private itemsBeforeDataLoad = 1;
	private questionsetResetSubscription;

	map: Array<any> = [];
	data = {
		id: null,
		side: null,
		name: null,
		seasons: [],
		stops: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly loader: LoaderService,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
		private readonly focustip: FocustipService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
		public service: MapService,
	) {}

	ngOnInit(): void {
		if (this.route.snapshot.params['id'] == 'add') {
			this.service.editable = true;
		} else {
			this.data.id = this.route.snapshot.params['id'];
		}
		this.loader.show();
		this.service.reset();
		this.loadBefore();
	}

	private loadBefore() {
		this.service.editable = true;
		this.service.destinations = [
			{
				id: 1,
				name: 'Program',
				from: [],
			},
		];
		this.api.get('/vehicles/?vehicle_status=4', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			console.log(result);
			result.data = result.data.map((item) => {
				item.destinations = [];
				item.type = 'vehicle';
				return item;
			});
			this.service.vehiclesAll = result.data;
			this.loadData();
		});
		this.api.get('/bag/bagStops/', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			result.data = result.data.map((item) => {
				item.destinations = [];
				this.service.destinations.forEach((destination) => {
					destination = JSON.parse(JSON.stringify(destination));
					destination.originCity = item.id;
					item.destinations.push(destination);
				});
				return item;
			});
			this.service.cities = result.data;
			this.mapComponent.generateMap();
		});
	}

	private loadData() {
		if (!this.data.id) {
			this.loader.hide();
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/bag/bagTransportTemplates/' + this.data.id, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.data = result.data;
			this.mapComponent.generateMap();
			this.loadSeasons();
		});
	}

	private loadSeasons() {
		this.data.seasons = [1];
		this.loadLogic();
	}

	private loadLogic() {
		this.api.get('/bag/bagTransportTemplatesLogic/?template=' + this.data.id, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			this.service.parse(result.data);

			// if (this.service.vehicles.length) {
			// 	this.service.selectVehicle(this.service.vehicles[0]);
			// }
		});
	}

	resetAll(): void {
		this.question.ask('Czy na pewno usunąć wszystkie połączenia i wybrane pojazdy?', 'resetAsk');
		this.questionsetResetSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'resetAsk') {
				return;
			}
			this.questionsetResetSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			this.api.del('/bag/bagTransportsLogic/' + this.data.id + '/', (result, error) => {
				location.reload();
			});
		});
	}

	submit(): void {
		if (!this.checkIfAllVehiclesHaveTarget()) {
			return;
		}
		if (!this.data.name) {
			this.focustip.show(document.getElementById('transportTemplatesName'), 'Nazwa nie została wypełniona');
			return;
		}
		if (this.data.id) {
			this.router.navigate(['transportTemplates', this.data.id, 'table']);
			return;
		}
		this.loader.show();
		this.api.post('/bag/bagTransportTemplates', this.data, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.data.id = result.data;
			this.submitTransports((result) => {
				if (!result) {
					return;
				}
				this.router.navigate(['transportTemplates', this.data.id, 'table']);
			});
		});
	}

	private checkIfAllVehiclesHaveTarget(): boolean {
		let allHaveTarget = true;
		this.service.vehicles.forEach((vehicle) => {
			if (!this.service.havePeople(vehicle)) {
				return;
			}
			if (this.service.haveBorder(vehicle)) {
				return;
			}
			this.infobox.error('Brak przystanku docelowego dla: ' + vehicle.name);
			allHaveTarget = false;
		});
		return allHaveTarget;
	}

	private submitTransports(callback) {
		const transports = this.service.transports.map((transport) => {
			if (!transport.destination) {
				transport.destination = {
					id: this.service.transports.find((obj) => obj.destination).destination.id,
					originCity: transport.city.id,
				};
			}
			return {
				template: this.data.id,
				originCity: transport.destination.originCity,
				city: transport.city.id,
				vehicle: transport.vehicle.id,
				action: transport.action,
				destination: transport.destination.id,
			};
		});
		this.api.post('/bag/bagTransportTemplatesLogic/' + this.data.id, transports, (result, error) => {
			this.loader.hide();
			if (error) {
				callback(false);
				return;
			}
			this.infobox.success('Zapisano');
			callback(true);
		});
	}

	nameUpdated(): void {
		if (this.data.name.length == 1) {
			this.focustip.hide();
		}
	}
}
